<template>
  <div class="h-dialogContainer">
    <form id="timingMissionForm">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">*{{$t('System.taskName')}}</div>
              <input id="missionName" class="e-input e-input-group" name="MissionName" v-model="missionName" :placeholder="$t('System.taskName')" :disabled="readonly" @change="setChildProps" />
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('System.oprType')}}</div>
          <ejs-dropdownlist ref="oprTypes" class="e-input e-disabled e-input-group" :dataSource="oprTypes" :index="0" :enabled="false" @change="setChildProps"></ejs-dropdownlist>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('System.module')}}</div>
          <ejs-dropdownlist ref="modules" class="e-input e-disabled e-input-group" :dataSource="modules" :index="0" @change="setChildProps" :enabled="!readonly"></ejs-dropdownlist>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('System.isEffective')}}</div>
          <ejs-dropdownlist ref="results" class="e-input e-disabled e-input-group" :dataSource="results" :index="0" @change="setChildProps"></ejs-dropdownlist>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div id="backupDay" style="display:none">

          <div class="col-sm-6 h-col-inputBox">
            <div class="h-inputLit">*{{$t('System.storeDays')}}</div>
            <div class="form-group">
              <input class="e-input e-input-group" v-model="backupDay" :disabled="isDB && isfmDB" @change="setChildProps" name ="BackupDay"/>
            </div>
          </div>
        </div>
        <!-- 修改 操作类型为数据库类型 显示 -->
        <div id="backupNum" style="display:none">
          <div class="col-sm-6 h-col-inputBox">
            <div class="h-inputLit">*{{$t('System.storeNumbers')}}</div>
            <div class="form-group">
            <input class="e-input e-input-group" v-model="backupNum" name ="BackupNum" @change="setChildProps"/>
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">*{{$t('System.startTime')}}</div>
          <ejs-datetimepicker ref="dataStart" class="e-input e-disabled e-input-group" name="StartDate" :format="dateFormat" :timeFormat="customFormat" v-model="startDate" :locale="locale" @change="setChildProps" :enabled="!readonly"></ejs-datetimepicker>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('System.endTime')}}</div>
          <ejs-datetimepicker ref="dataEnd" class="e-input e-input-group" name="EndDate" :format="dateFormat" :min="startDate" :timeFormat="customFormat" v-model="endDate" :locale="locale" @change="setChildProps"></ejs-datetimepicker>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="h-borderBox h-blueBg">
            <div class="row h-row-insertBox">
              <div class="col-sm-4 h-col-insertBox">
                <div class="h-inputLit">{{$t('System.runCycles')}}:</div>
                <ejs-dropdownlist ref="cycles" class="e-input e-disabled e-input-group" :dataSource="cycleArray"
                                  width="50%" @change="setCycleStatus" :enabled="!readonly || isFmAsync ||isBackup" v-model="indexValue"/>
              </div>
              <div id="minute" v-show="showMinute">
                <div class="col-sm-4 h-col-insertBox">
                  <div class="h-inputLit">{{$t('System.executionInterval')+'('+$t('System.minute') +')'}}</div>
                  <div class="e-float-input ">
                    <input ref="MinuteNum" class="e-input" placeholder="1-59" name="MinuteNum" v-model="minuteNum" :disabled="readonly" @change="setChildProps" />
                  </div>
                </div>
              </div>
              <div id="hour" v-show="showHour">
                  <div class="col-sm-4 h-col-insertBox">
                    <div class="h-inputLit">
                      {{$t('System.executionInterval')+'('+$t('System.hour') +')'}}
                    </div>
                    <div class="e-float-input ">
                      <input ref="HourNum" class="e-input " placeholder="1-23" name="HourNum" v-model="hourNum" :disabled="readonly && !isFmAsync" @change="setChildProps" />
                    </div>
                  </div>
              </div>
              <div id="day" v-show="showDay">
                  <div class="col-sm-4 h-col-insertBox">
                    <div class="h-inputLit">
                      {{$t('System.executionInterval')+'('+$t('System.day') +')'}}
                    </div>
                    <div class="e-float-input ">
                      <input ref="DayNum" class="e-input" placeholder="1-31" name="DayNum" v-model="dayNum" :disabled="readonly && !isFmAsync && !isBackup" @change="setChildProps" />
                    </div>
                </div>
              </div>
              <div id="week" v-show="showWeek">
                  <div class="col-sm-4 h-col-insertBox">
                    <div class="h-inputLit">{{$t('System.executionInterval')+'('+$t('System.week') +')'}}</div>
                    <div class="e-input-group e-control-wrapper">
                      <ejs-dropdownlist ref="week" class="e-input e-disabled" :dataSource="weeks" :index="0" @change="setChildProps" :enabled="!readonly || isBackup"></ejs-dropdownlist>
                    </div>
                  </div>
              </div>
              <div id="month" v-show="showMonth">
                  <div class="col-sm-4 h-col-insertBox">
                    <div class="h-inputLit">{{$t('System.executionInterval')+'('+$t('System.month') +')'}}</div>
                    <div class="e-input-group e-control-wrapper">
                      <ejs-dropdownlist ref="chooseMonth" class="e-input e-disabled" :dataSource="months" :index="0" @change="setChildProps" :enabled="!readonly"></ejs-dropdownlist>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="h-inputLit">{{$t('System.description')}}：</div>
          <ejs-textbox :placeholder="$t('System.inputTip')" name="MissionRemark" v-model="info" :multiline="true" @change="setChildProps" />
        </div>
      </div>
      <div class="row h-row-inputBox" id="upFile" styel="display:none">
        <div class="h-system-hide-upload">
          <ejs-uploader ref="file" name="File" id="fileTxt" autoUpload="false" :selected="onFileSelect" allowedExtensions=".txt" :multiple="true"></ejs-uploader>
        </div>
        <div class='h-col-inputBox'>
          <div class='h-borderBox h-system-height-280'>
            <div class='h-system-borderBox-top'>
              {{$t('System.selectFile')}}
              <div class="h-system-btn-box">
                <ejs-button iconCss="icon hero-icon hero-icon-add-small hero-system-icon-add-small" cssClass="e-small e-round" :isPrimary="true" iconPosition="center" @click.native="upFile" type="button"></ejs-button>
              </div>
            </div>
            <div class='h-system-overflow'>
              <div v-for='(filename, index) in filesname' :key='index'>
                <div class='h-system-mission-file h-inputLit'>{{filename}}</div>
                <div class='h-system-del-btn-box'>
                  <ejs-button iconCss="icon hero-icon hero-icon-remove-small" cssClass="e-small e-round" :isPrimary="true" @click.native="delTxtShow(index)" type="button"></ejs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import CustomDialog from "../../components/common/CustomDialog";
import mixin from '../../mixin/mixin';
import {EventBus} from "../../plugins/eventBus";
import DateUtil from "../pmConfig/util/DateUtil";

export default {
  name: "TimingMission",
  mixins: [mixin],
  props: {
    createOrEdit: Number, // create 0 / edit 1
    sysCustom: Number // sys 0 / custom 1
  },
  data() {
    return {
      isFmAsync: false,
      isBackup: false,
      isfmDB: true,
      locale: localStorage.getItem('locale'),
      formObj: "",
      customFormat: "HH:mm",
      readonly: false,
      isDB: false,
      corntabid: 0,
      missionName: "",
      oprTypes: [
        { text: `${this.$t("System.mmlMiss")}`, value: "1" },
        { text: `${this.$t("System.db")}`, value: "2" },
        { text: `${this.$t("System.systemFile")}`, value: "3" },
        { text: `${this.$t('System.3gppMiss')}`, value: "4" },
        { text: `${this.$t('System.backup')}`, value: "5" }
      ],
      modules: [
        { text: `${this.$t("System.config")}`, value: 1 },
        { text: `${this.$t("System.fm")}`, value: 2 },
        { text: `${this.$t("System.alarm")}`, value: 3 },
      ],
      modulesSys: [
        { text: `${this.$t("System.config")}`, value: 1 },
        { text: `${this.$t("System.fm")}`, value: 2 },
        { text: `${this.$t("System.alarm")}`, value: 3 },
        { text: `${this.$t("System.systemManager")}`, value: 5 }
      ],
      results: [
        { text: `${this.$t("System.yes")}`, value: 1 },
        { text: `${this.$t("System.no")}`, value: 0 }
      ],
      cycleArray: [
        { text: `${this.$t("System.minute")}`, value: 0 },
        { text: `${this.$t("System.hour")}`, value: 1 },
        { text: `${this.$t("System.day")}`, value: 2 },
        { text: `${this.$t("System.weeks")}`, value: 3 },
        { text: `${this.$t("System.month")}`, value: 4 }
      ],
      weeks: [
        { text: `${this.$t("Security.Strategy.sunday")}`, value: 1 },
        { text: `${this.$t("Security.Strategy.monday")}`, value: 2 },
        { text: `${this.$t("Security.Strategy.tuesday")}`, value: 3 },
        { text: `${this.$t("Security.Strategy.wednesday")}`, value: 4 },
        { text: `${this.$t("Security.Strategy.thursday")}`, value: 5 },
        { text: `${this.$t("Security.Strategy.friday")}`, value: 6 },
        { text: `${this.$t("Security.Strategy.saturday")}`, value: 7 }
      ],
      months: [
        { text: "1", value: 1 },
        { text: "2", value: 2},
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
        { text: "9", value: 9 },
        { text: "10", value: 10 },
        { text: "11", value: 11 },
        { text: "12", value: 12 }
      ],
      days: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
        16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28,
        29, 30, 31
      ],
      weekNums: [
        { text: "1st", value: 1 },
        { text: "2nd", value: 2 },
        { text: "3rd", value: 3 },
        { text: "4th", value: 4 }
      ],
      dateFormat: "yyyy-MM-dd HH:mm",
      initDate: this.calTime(),
      startDate: "",
      endDate: "",
      cronDate: "",
      minuteNum: 30,
      hourNum: 1,
      dayNum: "1",
      monthNum: "",
      showMinute: true,
      showHour: false,
      showDay: false,
      showWeek: false,
      showMonth: false,
      info: "",
      sysTaskType: "2",
      cornValue: {},
      backupDay: "",
      backupNum: 0,
      inputNames: ['MissionName',"MissionRemark", 'StartDate','EndDate','MinuteNum','HourNum','DayNum','BackupNum', 'BackupDay'],
      rules: {
        StartDate:{required:true,regex:'datemin'},
        EndDate:{regex:'datemin'},
        MinuteNum:{regex:'integer', range:[1,59]},
        HourNum:{regex:'integer',range:[1,23]},
        DayNum:{regex:'integer',range:[1,31]},
        MissionName: { required: true,regex: 'specialWordWithSpace', maxLength:64 },
        MissionRemark: { maxLength:128 },
        BackupNum:{regex:'integer',range:[0,1500000],minLength:1},
        BackupDay:{regex:'integer',range:[1,365],minLength:1},
      },
      sysTaskId: this.formatTime(new Date()),
      filesname: [],
      indexValue:0
    };
  },
  methods: {
    setChildProps() {
      const crontabs = [];
      crontabs.push(this.getCornValue());
      if(this.filesname.length > 0){
        const isJson = this.isJson(this.filesname[0]);
        if (isJson) {
          const filename = JSON.parse(this.filesname[0]);
          if(filename['execTime']){
            if(this.backupDay ==''){
              this.backupDay = 30;
            }
            filename['execTime'] = this.backupDay;
          }
          if(filename['execNum']){
            if(this.backupNum ==''){
              this.backupNum =2000;
            }
            filename['execNum'] = this.backupNum;
          }
          this.filesname[0] = JSON.stringify(filename);
        }
      }
      this.$emit("childProps", {
        crontabs: crontabs,
        filesname: this.filesname,
        moduleId: this.modules[this.$refs.modules.ej2Instances.index].value,
        sysTaskBegTime: this.startDate,
        sysTaskEndTime: this.endDate,
        sysTaskEfitRemark: this.info,
        sysTaskId: this.sysTaskId,
        sysTaskName: this.missionName,
        sysTaskOsType: this.oprTypes[this.$refs.oprTypes.ej2Instances.index].value,
        sysTaskType: this.sysTaskType,
        taskSwitch: this.results[this.$refs.results.ej2Instances.index].value
      });
    },
    onFileSelect(args) {
      const file = args.filesData;
      file.forEach(item => this.filesname.push(item.name));
      this.upLoadTxt(file);
      this.setChildProps();
    },
    upLoadTxt(file) {
      const url = "/lte/ems/sysmanager/task/upload";
      let formData = new FormData();
      formData.append("taskid", this.sysTaskId);
      formData.append("file", file[0].rawFile);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios.post(url, formData, config).then(response => {});
    },
    setCycleStatus() {
      let index = this.$refs.cycles.ej2Instances.index;
      console.log("setCycleStatus index:"+index)
      if(this.isBackup){
        if (index === 0) {
          this.showMinute = false;
          this.showHour = false;
          this.showDay = true;
          this.showWeek = false;
          this.showMonth = false;
        } else if (index === 1) {
          this.showMinute = false;
          this.showHour = false;
          this.showDay = false;
          this.showWeek = true;
          this.showMonth = false;
        } else {
          this.showMinute = false;
          this.showHour = false;
          this.showDay = true;
          this.showWeek = false;
          this.showMonth = false;
        }
      }else{
        if (index === 0) {
          this.showMinute = true;
          this.showHour = false;
          this.showDay = false;
          this.showWeek = false;
          this.showMonth = false;
        } else if (index === 1) {
          this.showMinute = false;
          this.showHour = true;
          this.showDay = false;
          this.showWeek = false;
          this.showMonth = false;
        } else if (index === 2) {
          this.showMinute = false;
          this.showHour = false;
          this.showDay = true;
          this.showWeek = false;
          this.showMonth = false;
        } else if (index === 3) {
          this.showMinute = false;
          this.showHour = false;
          this.showDay = false;
          this.showWeek = true;
          this.showMonth = false;
        } else {
          this.showMinute = false;
          this.showHour = false;
          this.showDay = false;
          this.showWeek = false;
          this.showMonth = true;
        }
      }
      if (this.sysTaskId === "31000003") {
        this.minuteNum = 15;
      } else {
        this.minuteNum = 30;
      }
      this.setChildProps();
    },
    calTime(){
      const current = new Date().getTime();
      return new Date(current+600000);
    },
    // 时间格式化
    formatTime(time) {
      const mask = "yyyy MM dd HH mm ss l";
      let d = time;
      let zeroize = (value, length) => {
        if (!length) {
          length = 2;
        }
        value = String(value);
        let zeros = "";
        for (let i = 0; i < length - value.length; i++) {
          zeros += "0";
        }
        return zeros + value;
      };
      return mask
        .replace(
        /"[^"]*"|'[^']*'|\b(?:d{1,4}|m{1,4}|yy(?:yy)?|([hHMstT])\1?|[lLZ])\b/g,
        function ($0) {
          switch ($0) {
            case "dd":
              return zeroize(d.getDate());
            case "MM":
              return zeroize(d.getMonth() + 1);
            case "yyyy":
              return d.getFullYear();
            case "HH":
              return zeroize(d.getHours());
            case "mm":
              return zeroize(d.getMinutes());
            case "ss":
              return zeroize(d.getSeconds());
            case "l":
              return zeroize(d.getMilliseconds(), 3);
            default:
              return $0.substr(1, $0.length - 2);
          }
        }
        )
        .replace(/ /g, "");
    },
    getCornValue() {
      if(this.cronDate === ""){
        this.cronDate = (this.startDate==""?this.calTime():this.startDate);
      }
      if(this.isBackup){
        this.cronDate = (this.startDate==""?this.calTime():this.startDate);
      }
      if (this.showMinute) {
        if (this.minuteNum == null || this.minuteNum == "") {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.timeRangeNotNull')});
          return false;
        }
        /*if (this.minuteNum > 59 || this.minuteNum < 1) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.minuteRangeInvalid')});
          return false;
        }*/
        this.cornValue = this.cornItem(
          "2/" + this.minuteNum,
          null,
          "1/1",
          null,
          "?"
        );
      }
      if (this.showHour) {
        if (this.hourNum == null || this.hourNum == "") {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.timeRangeNotNull')});
          return false;
        }
        /*if(this.hourNum > 23 || this.hourNum < 1){
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.hourRangeInvalid')});
          return false;
        }*/
        if (this.sysTaskId === "31000003") {
          this.cornValue = this.cornItem(
            this.startDate.getMinutes() + 9,
            "0/"+this.hourNum,
            "1/1",
            null,
            "?"
          );
        } else {
          this.cornValue = this.cornItem(
            this.cronDate.getMinutes(),
            "0/"+this.hourNum,
            "1/1",
            null,
            "?"
          );
        }
      }
      if (this.showDay) {
        if (this.dayNum == null || this.dayNum == "") {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.timeRangeNotNull')});
          return false;
        }
        /*if (this.dayNum > 31 || this.dayNum < 1) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.dayRangeInvalid')});
          return false;
        }*/
        if (this.sysTaskId === "31000003") {
          this.cornValue = this.cornItem(
            this.startDate.getMinutes(),
             3,
            "1/" + this.dayNum,
            null,
            "?"
          );
        } else {
          this.cornValue = this.cornItem(
            this.cronDate.getMinutes(),
            this.cronDate.getHours(),
            "1/" + this.dayNum,
            null,
            "?"
          );
        }
      }
      if (this.showWeek) {
        this.cornValue = this.cornItem(
          this.cronDate.getMinutes(),
          this.cronDate.getHours(),
          "?",
          null,
          this.weeks[this.$refs.week.ej2Instances.index].value
        );
      }
      if (this.showMonth) {
        this.cornValue = this.cornItem(
          this.cronDate.getMinutes(),
          this.cronDate.getHours(),
          this.cronDate.getDate(),
          "1/"+this.months[this.$refs.chooseMonth.ej2Instances.index].value,
          "?"
        );
      }
      if(this.sysTaskId === "60000001"){
        this.cornValue.hour="0";
        this.cornValue.minute="33";
      }
      if(this.showDay&&this.sysTaskId === "31000006"){
        this.cornValue.hour="3";
        this.cornValue.minute="0";
      }
      return {
        crontabstring:
        this.cornValue.minute +
        " " +
        this.cornValue.hour +
        " " +
        this.cornValue.day +
        " " +
        this.cornValue.month +
        " " +
        this.cornValue.dayOfWeek
      };
    },
    analysisCrontab(crontabString) {
      // 分cronArr[0] + " " + 时cronArr[1] + " " + 天cronArr[2] + " " + 月cronArr[3] + " " + 周cronArr[4]
      const cronArr = crontabString.split(" ");
      const dateStr = DateUtil.getDateString(this.startDate).substr(0, 10);
      let temTimeStr =dateStr + " "+cronArr[1] + ":" + cronArr[0];
      if(this.sysTaskId === "60000001"){
        this.cycleArray=[
          { text: `${this.$t("System.day")}`, value: 0 },
          { text: `${this.$t("System.week")}`, value: 1 },
        ]
        this.$refs.cycles.ej2Instances.bindValidate;
        if (cronArr[4] != "?" && cronArr[4].indexOf("-") === -1) {
          // 周
          this.$refs.cycles.ej2Instances.index = 1;
          this.$refs.week.ej2Instances.index = cronArr[4] - 1;
          this.indexValue = 1;
        }else{
          // 天
          this.$refs.cycles.ej2Instances.index = 0;
          this.dayNum = cronArr[2].split("/")[1];
          this.indexValue = 0;
        }
      } else if (this.sysTaskId === "31000003") {
        if (cronArr[0].includes(',') || cronArr[0].includes('/')) {
          //代表执行周期选择：分钟
          this.$refs.cycles.ej2Instances.index = 0;
          this.minuteNum = 15;
        } else if (cronArr[1].includes('/')) {
          //代表执行周期选择：小时
          this.$refs.cycles.ej2Instances.index = 1;
        } else if (!cronArr[0].includes(',') && !cronArr[0].includes('/') && !cronArr[1].includes('/')) {
          //代表执行周期选择：天
          this.$refs.cycles.ej2Instances.index = 2;
        }
        temTimeStr =dateStr + " "+this.startDate.getHours() + ":"+this.startDate.getMinutes();
      } else {
        if (cronArr[3] != "*") {
          // 月
          this.$refs.cycles.ej2Instances.index = 4;
          this.$refs.chooseMonth.ej2Instances.index = cronArr[3].split("/")[1]-1;
        } else if (cronArr[4] != "?" && cronArr[4].indexOf("-") === -1) {
          // 周
          this.$refs.cycles.ej2Instances.index = 3;
          this.$refs.week.ej2Instances.index = cronArr[4] - 1;
        } else if (cronArr[1] === "*" && cronArr[0].indexOf("/") !== -1) {
          // 分钟
          this.$refs.cycles.ej2Instances.index = 0;
          this.minuteNum = cronArr[0].split("/")[1];
          temTimeStr =dateStr + " "+this.startDate.getHours() + ":"+this.startDate.getMinutes();

        } else if (cronArr[1].indexOf("/") !== -1) {
          // 小时
          this.$refs.cycles.ej2Instances.index = 1;
          this.hourNum = cronArr[1].split("/")[1];
          temTimeStr =dateStr + " " +this.startDate.getHours()+ ":" + cronArr[0];
        } else {
          // 天
          this.$refs.cycles.ej2Instances.index = 2;
          this.dayNum = cronArr[2].split("/")[1];
        }
      }
      this.cronDate = new Date(Date.parse(temTimeStr.replace("/-/g", "/")));
    },
    cornItem(minute, hour, day, month, dayOfWeek) {
      return {
        minute: minute == null ? "*" : minute,
        hour: hour == null ? "*" : hour,
        day: day == null ? "*" : day,
        month: month == null ? "*" : month,
        dayOfWeek: dayOfWeek == null ? "*" : dayOfWeek
      };
    },
    setDialogState() {
      if (this.createOrEdit === 0) {
        document.getElementById("upFile").style.display = "block";
        document.getElementById("backupNum").style.display = "none";
        document.getElementById("backupDay").style.display = "none";
        this.readonly = false;
      } else {
        this.isDB = true;
        if (this.$refs.oprTypes.ej2Instances.index === 0) {
          this.isDB = false;
        }
        document.getElementById("backupNum").style.display = "none";
        if (this.$refs.oprTypes.ej2Instances.index === 1) {
          document.getElementById("backupNum").style.display = "block";
        }
        this.$refs.dataStart.ej2Instances.readonly = true;
        // 系统任务修改
        if (this.sysCustom === 0) {
          document.getElementById("missionName").disabled = true;
          document.getElementById("upFile").style.display = "none";
          if (this.backupDay == null || this.backupDay == "") {
            document.getElementById("backupDay").style.display = "none";
          } else {
            document.getElementById("backupDay").style.display = "block";
          }
          if (this.backupNum == null || this.backupNum == '') {
            document.getElementById("backupNum").style.display = "none";
          } else {
            document.getElementById("backupNum").style.display = "block";
          }
          this.readonly = true;
          if(this.sysTaskId === '30000002'){
            this.isfmDB=false;
          }if(this.sysTaskId === '31000001' || this.sysTaskId === '31000002' || this.sysTaskId === '31000003' || this.sysTaskId === '31000006') {
            this.isfmDB = false;
            this.isFmAsync = true;
            this.cycleArray=[
              { text: `${this.$t("System.minute")}`, value: 0 },
              { text: `${this.$t("System.hour")}`, value: 1 },
              { text: `${this.$t("System.day")}`, value: 2 },
            ];
            this.$refs.MinuteNum.disabled = true;
            this.$refs.HourNum.disabled = true;
            this.$refs.DayNum.disabled = true;
          }else if(this.sysTaskId === '30000005'){
            this.isFmAsync = true;
            document.getElementById("backupNum").style.display = "none";
            document.getElementById("backupDay").style.display = "none";
            this.cycleArray=[
              { text: `${this.$t("System.minute")}`, value: 0 },
              { text: `${this.$t("System.hour")}`, value: 1 },
              { text: `${this.$t("System.day")}`, value: 2 },
            ];
            this.$refs.MinuteNum.disabled = true;
            this.$refs.HourNum.disabled = true;
            this.$refs.DayNum.disabled = true;
          }else if(this.sysTaskId === '60000001'){
            this.isBackup = true;
            this.$refs.dataStart.ej2Instances.readonly = false;
          } else if(this.sysTaskId === '31000004'){
            this.isDB = false;
            this.$refs.cycles.disabled = true;
          } else if (this.sysTaskId === '31000006') {
            this.isDB = false;
            this.isfmDB = false;
          } else if (this.sysTaskId === '12017001') {
            this.isDB = false;
            this.isfmDB = false;
          }
        } else {
          //自定义任务修改
          document.getElementById("missionName").disabled = false;
          document.getElementById("upFile").style.display = "block";
          document.getElementById("backupDay").style.display = "none";
          this.readonly = false;
        }
      }
    },
    backfillParams(editParams) {
      this.$loading.showLoadding(`${this.$t('System.loading')}`);
      this.modules = this.modulesSys;
      const param = editParams;
      this.sysTaskId = param.taskIdString;
      this.missionName = param.sysTaskName;
      this.oprTypes.forEach((item, index) => {
        if (item.value === param.sysTaskOsType) {
          this.$refs.oprTypes.ej2Instances.index = index;
        }
      });
      this.modules.forEach((item, index) => {
        if (item.value === param.moduleId) {
          this.$refs.modules.ej2Instances.index = index;
        }
      });
      this.results.forEach((item, index) => {
        if (item.value === param.taskSwitch) {
          this.$refs.results.ej2Instances.index = index;
        }
      });
      this.startDate = new Date(param.sysTaskBegTime);
      if (param.sysTaskEndTime != null) {
        this.endDate = new Date(param.sysTaskEndTime);
      }
      //设置执行周期
      const crontabstring = param.crontabs[0].crontabstring;
      this.analysisCrontab(crontabstring);
      // 自定义任务会回填file文件
      const isJson = this.isJson(param.filesname[0]);
      if (isJson) {
        const filename = JSON.parse(param.filesname[0]);
        this.backupDay = filename['execTime'];
        this.backupNum = filename['execNum'];
      }
      this.filesname = param.filesname;
      this.info = param.sysTaskEfitRemark;
      this.setDialogState();
      this.$loading.hideLoadding();
    },
    isJson(str) {
      if (typeof str == 'string') {
        try {
          JSON.parse(str);
          return true;
        } catch (e) {
          return false;
        }
      }
    },
    upFile() {
      document
        .getElementsByClassName("e-file-select-wrap")[0]
        .querySelector("button")
        .click();
      return false;
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    },
    bindValidate() {
      this.formObj = this.validateForm('timingMissionForm', this.inputNames, this.rules);
    },
    delTxtShow(index) {
      this.filesname.splice(index, 1);
      if (document.getElementsByClassName('e-file-remove-btn')) {
        const element = document.getElementsByClassName('e-file-remove-btn')[0];
        element.click();
      }
    }
  },
  components: {
    CustomDialog
  },

  checkAmount(value,callback) {
                if (!value) {
                    callback(new Error('时间不能为空'));
                } else {
                    callback();
                }
            },
  watch: {
    createOrEdit() {
      this.setDialogState();
    }

  }
};
</script>
